module.exports = __webpack_public_path__ + "static/media/1010098.c84b6620.jpg";